import { Cirus } from "@/classes/Http";
import { AxiosResponse } from "axios";

class ChoiceOption {
    id: string;
    name: string;
    available = false;
}

class PriceChoiceOption extends ChoiceOption {
    price: number;
    price_with_off: number;
    off_percent: number;
}

class PriceChoice {
    title: string;
    options:  PriceChoiceOption[];
}

class Choice {
    id: string;
    title: string;
    options:  ChoiceOption[];
}


export class GetProductSoldInvoiceChoiceResponse {
    value_without_off: number;
    value: number;
    count = 0;
    price_choice: PriceChoice;
    other_choices: Choice[];
}

export function getProductSoldInvoiceChoices(product_id: string): Promise<AxiosResponse<GetProductSoldInvoiceChoiceResponse>> {
    const query = `/product/${product_id}/sold-invoice-choices`;
    return Cirus.get(query);
}